import _ from "lodash"
import BigNumber from "bignumber.js"
import dayjs from "dayjs"
import { nodeDistClientList } from "node-dist/nodeDistManager"
import { GetTicketKey } from "node-dist/nodeDistFlag"

const push_meta = [
  "Ask",
  "AskQuoteFlag",
  "AskVolume",
  "Bid",
  "BidQuoteFlag",
  "BidVolume",
  "CalculatedPrice",
  "Delta",
  "DepthOfAskPrice",
  "DepthOfBidPrice",
  "Gamma",
  "HighPrice",
  "HighPriceTime",
  "LastClose",
  "LastCloseTime",
  "ListedHighPrice",
  "ListedHighDay",
  "ListedLowPrice",
  "ListedLowDay",
  "LowPrice",
  "LowPriceTime",
  "Market",
  "MarketAskQty",
  "MarketBidQty",
  "No",
  "OpenPrice",
  "OpenPriceTime",
  "Over",
  "OverQty",
  "Price",
  "PriceStatus",
  "PriceTime",
  "SesstionStatus",
  "ShortSellingFlag",
  "Theta",
  "TradValue",
  "TradVolume",
  "TickCount",
  "UpCount",
  "DownCount",
  "Under",
  "UnderQty",
  "VWAP",
  "Vega",
  "Volatility",
  "YearlyHighDay",
  "YearlyLowDay",
  "YearlyHighPrice",
  "YearlyLowPrice",
  //socketから来ないがSOCKET_MESSAGEの時に付与します
  "PriceCompareText",
  "PriceStatusText",
  "CalcLastClose",
  "ChangedPrice",
  "ChangedRatio",
  "OpenChangedPrice",
  "OpenChangedRatio",
]

interface symbolObj {
  pausePush?: boolean
  DepthOfAskPrice?: Array<object>
  DepthOfBidPrice?: Array<object>
  PriceCompareText?: string
  PriceStatus?: string
  PriceStatusText?: string
  LastCloseTime?: string
  HighPriceTime?: string
  LowPriceTime?: string
  OpenPriceTime?: string
  PriceTime?: string
  Price?: number
  ChangedRatio?: number
  LastClose?: number
  CalcLastClose?: number
  OpenPrice?: number
  ChangedPrice?: number
}

const INT_MINI = -2147483648

/************************************
 * ACTION TYPE
 ************************************/
const SOCKET_MESSAGE = "SOCKET_MESSAGE"
export const API_MESSAGE = "API_MESSAGE"
export const PAUSE_PUSH = "PAUSE_PUSH"
export const SOCKET_UN_REGISTER = "SOCKET_UN_REGISTER"

/************************************
 * ACTIONS
 ************************************/
export function updatePushFromAPI(symbols: Array<object> = []) {
  return (dispatch: Function) => {
    dispatch({
      type: API_MESSAGE,
      value: symbols,
    })
  }
}

let isSocketResponsing = false

export const updatePushFromSocket = (msg: any) => {
  isSocketResponsing = true
  return (dispatch: Function) => {
    const symbolKeys = Object.keys(msg.data)
    symbolKeys.forEach(key => {
      msg.data[key] = {
        ...msg.data[key].price,
        ...msg.data[key].book,
      }
    })
    dispatch({
      type: SOCKET_MESSAGE,
      value: msg.data,
    })
  }
}

export function unregister(unregisterList: Array<string>) {
  return (dispatch: Function): void =>
    dispatch({
      type: SOCKET_UN_REGISTER,
      value: _.map(unregisterList, ticket =>
        ticket.substring(0, ticket.indexOf("@MarketInfoFull"))
      ),
    })
}

export function updatePausePush(value: boolean) {
  return {
    type: PAUSE_PUSH,
    value,
  }
}

const initialState = {
  pausePush: false,
}

export default (
  state: symbolObj = initialState,
  action: { type?: string; value?: object } = {}
) => {
  let _state: any
  switch (action.type) {
    case SOCKET_MESSAGE:
      _state = { ...state }
      action.value = _.mapValues(
        action.value,
        (
          pushSymbol: symbolObj & {
            [key: string]: string | boolean | object[] | number
          },
          key
        ) => {
          // PUSHの監視
          //   if (!_.isEmpty(config.api.dummy_push_log)) {
          //     watchSymbolPush(key.split('@')[2], pushSymbol, 'SYMBOL :')
          //   }
          let stateSymbol: symbolObj = _state[key]
          if (stateSymbol) {
            if (!_.every(pushSymbol.DepthOfAskPrice, item => _.isEmpty(item))) {
              stateSymbol.DepthOfAskPrice =
                stateSymbol.DepthOfAskPrice ||
                _.times(10, index => ({ Index: index + 1 }))
              pushSymbol.DepthOfAskPrice = _.map(
                stateSymbol.DepthOfAskPrice,
                (item, index) =>
                  _.merge({}, item, pushSymbol.DepthOfAskPrice[index])
              )
            } else {
              pushSymbol.DepthOfAskPrice = stateSymbol.DepthOfAskPrice
            }
            if (!_.every(pushSymbol.DepthOfBidPrice, item => _.isEmpty(item))) {
              stateSymbol.DepthOfBidPrice =
                stateSymbol.DepthOfBidPrice ||
                _.times(10, index => ({ Index: index + 1 }))
              pushSymbol.DepthOfBidPrice = _.map(
                stateSymbol.DepthOfBidPrice,
                (item, index) =>
                  _.merge({}, item, pushSymbol.DepthOfBidPrice[index])
              )
            } else {
              pushSymbol.DepthOfBidPrice = stateSymbol.DepthOfBidPrice
            }
          }
          if (pushSymbol.PriceCompare !== undefined) {
            switch (pushSymbol.PriceCompare) {
              case "0000": {
                pushSymbol.PriceCompareText = "　"
                break
              }
              //変わらず
              case "0056": {
                pushSymbol.PriceCompareText = "　"
                break
              }
              //値上がり
              case "0057": {
                pushSymbol.PriceCompareText = "↑"
                break
              }
              //値下がり
              case "0058": {
                pushSymbol.PriceCompareText = "↓"
                break
              }
              //中断板寄り後の初値
              case "0059": {
                pushSymbol.PriceCompareText = "："
                break
              }
              //ザラバ引け
              case "0060": {
                pushSymbol.PriceCompareText = "・"
                break
              }
              //板寄り引け
              case "0061": {
                pushSymbol.PriceCompareText = "o"
                break
              }
              //中断引け
              case "0062": {
                pushSymbol.PriceCompareText = "◎"
                break
              }
              //ダウン引け
              case "0063": {
                pushSymbol.PriceCompareText = "○"
                break
              }
              //逆転終値
              case "0064": {
                pushSymbol.PriceCompareText = "×"
                break
              }
              //売買停止引け
              case "0068": {
                pushSymbol.PriceCompareText = "停"

                break
              }
              //サーキットブレーカー引け
              case "0069": {
                pushSymbol.PriceCompareText = "サ"
                break
              }
              //DCB引け(OMX)
              case "0431":
                pushSymbol.PriceCompareText = "サ"
                break
              default:
                pushSymbol.PriceCompareText = "　"
                break
            }
          }

          if (pushSymbol.PriceStatus !== undefined) {
            switch (pushSymbol.PriceStatus) {
              case "A0":
                pushSymbol.PriceStatusText = "売停"
                break
              case "A1":
                pushSymbol.PriceStatusText = ""
                break
              case "B0":
                pushSymbol.PriceStatusText = "板寄"
                break
              case "B1":
                pushSymbol.PriceStatusText = ""
                break
              case "C0":
                pushSymbol.PriceStatusText = "中断"
                break
              case "C1":
                pushSymbol.PriceStatusText = ""
                break
              case "D0":
                pushSymbol.PriceStatusText = "売停"
                break
              default:
                // 東証から配られるスペースの形式が不明なのでdefaultで対応
                pushSymbol.PriceStatusText = ""
                break
            }
          }

          //クリア電文か、値があるときだけ日付を上書き、
          _.map(
            [
              "LastCloseTime",
              "HighPriceTime",
              "LowPriceTime",
              "OpenPriceTime",
              "PriceTime",
            ],
            key => {
              if (pushSymbol[key] !== undefined) {
                pushSymbol[key] = pushSymbol[key]
                  ? dayjs(pushSymbol[key] as string).format("YYYYMMDDHHmmss")
                  : null
              }
            }
          )

          //stateSymbolのDepthOfAskPriceとDepthOfBidPriceのデーターをpushSymbolに書き込んだので削除
          const _omit = ["DepthOfAskPrice", "DepthOfBidPrice"]

          pushSymbol = {
            ..._.omit(stateSymbol, _omit),
            ...pushSymbol,
          }

          //株
          let lastCloseKey = "LastClose"
          if (key.split("@")[1] === "E") {
            //株はcalclastclose
            lastCloseKey = "CalcLastClose"
            if (pushSymbol.LastClose !== undefined) {
              pushSymbol["CalcLastClose"] = pushSymbol.LastClose
            }
          }

          if (
            pushSymbol.Price === INT_MINI ||
            pushSymbol[lastCloseKey] === INT_MINI ||
            !pushSymbol.Price ||
            !pushSymbol[lastCloseKey]
          ) {
            pushSymbol.ChangedPrice = INT_MINI
            pushSymbol.ChangedRatio = INT_MINI
          } else {
            pushSymbol.ChangedPrice = new BigNumber(pushSymbol.Price)
              .minus(pushSymbol[lastCloseKey] as number)
              .toNumber()
            pushSymbol.ChangedRatio = Number(
              new BigNumber(pushSymbol.ChangedPrice)
                .div(pushSymbol[lastCloseKey] as number)
                .times(100)
                .decimalPlaces(
                  2,
                  key.split("@")[1] === "N"
                    ? BigNumber.ROUND_HALF_UP
                    : BigNumber.ROUND_FLOOR
                )
                .toFixed(2)
            )
            pushSymbol.ChangedRatio = parseFloat(
              String(pushSymbol.ChangedRatio)
            )
          }

          //始値比の騰落率の計算
          if (
            pushSymbol.Price === INT_MINI ||
            pushSymbol.OpenPrice === INT_MINI ||
            !pushSymbol.Price ||
            !pushSymbol.OpenPrice
          ) {
            pushSymbol.OpenChangedRatio = INT_MINI
            pushSymbol.OpenChangedPrice = INT_MINI
          } else {
            pushSymbol.OpenChangedPrice = new BigNumber(pushSymbol.Price)
              .minus(pushSymbol.OpenPrice)
              .toNumber()
            pushSymbol.OpenChangedRatio = new BigNumber(
              pushSymbol.OpenChangedPrice
            )
              .div(pushSymbol.OpenPrice)
              .times(100)
              .decimalPlaces(2, BigNumber.ROUND_FLOOR)
              .toFixed(2)
            pushSymbol.OpenChangedRatio = parseFloat(
              pushSymbol.OpenChangedRatio
            )
          }

          return pushSymbol
        }
      )
      _state = { ...state, ...action.value }
      return _state
    case SOCKET_UN_REGISTER:
      _state = { ...state }
      _.forEach(action.value, ticket => delete _state[ticket])
      return _state
    case API_MESSAGE:
      const symbols = _.isArray(action.value) ? action.value : [action.value]
      _state = { ...state }

      const nodeDistClient = _.get(nodeDistClientList, "PushSymbol", undefined)
      const _registeredList = _.get(nodeDistClient, "_registeredList", [])

      symbols.forEach(symbol => {
        const key = GetTicketKey(symbol)

        if (
          nodeDistClient &&
          nodeDistClient.isConnect() &&
          isSocketResponsing &&
          !state.pausePush
        ) {
          const isRegistred = _.findIndex(_registeredList, (i: string) =>
            _.startsWith(i, key)
          )
          //registに入っている銘柄であればストアを更新させません。
          if (isRegistred > -1) return
        }

        if (_state[key] === undefined) {
          _state[key] = _.pick(symbol, push_meta)
        } else {
          if (
            dayjs(symbol.HighPriceTime, "YYYYMMDDHHmmss").isAfter(
              dayjs(_state[key].HighPriceTime, "YYYYMMDDHHmmss")
            )
          ) {
            _state[key].HighPrice = symbol.HighPrice
            _state[key].HighPriceTime = symbol.HighPriceTime
          }

          if (
            dayjs(symbol.LowPriceTime, "YYYYMMDDHHmmss").isAfter(
              dayjs(_state[key].LowPriceTime, "YYYYMMDDHHmmss")
            )
          ) {
            _state[key].LowPrice = symbol.LowPrice
            _state[key].LowPriceTime = symbol.LowPriceTime
          }

          if (
            dayjs(symbol.OpenPriceTime, "YYYYMMDDHHmmss").isAfter(
              dayjs(_state[key].OpenPriceTime, "YYYYMMDDHHmmss")
            )
          ) {
            _state[key].OpenPrice = symbol.OpenPrice
            _state[key].OpenPriceTime = symbol.OpenPriceTime
          }

          if (
            dayjs(symbol.LastCloseTime, "YYYYMMDDHHmmss").isAfter(
              dayjs(_state[key].LastCloseTime, "YYYYMMDDHHmmss")
            )
          ) {
            _state[key].LastClose = symbol.LastClose
            _state[key].LastCloseTime = symbol.LastCloseTime
          }

          if (
            dayjs(symbol.PriceTime, "YYYYMMDDHHmmss").isAfter(
              dayjs(_state[key].PriceTime, "YYYYMMDDHHmmss")
            )
          ) {
            _state[key].Price = symbol.Price
            _state[key].PriceTime = symbol.PriceTime
          }

          const _omit = [
            "HighPrice",
            "HighPriceTime",
            "LastClose",
            "LastCloseTime",
            "LowPrice",
            "LowPriceTime",
            "OpenPrice",
            "OpenPriceTime",
            "Price",
            "PriceTime",
          ]

          _state[key] = {
            ..._state[key],
            ..._.pick(_.omit(symbol, _omit), push_meta),
          }
        }
      })

      return _state
    case PAUSE_PUSH:
      _state = { ...state }
      _state.pausePush = action.value
      return _state
    default:
      return state
  }
}
